const BrandColors = {
  SEMANTIC_COLOR_PRIMARY: "teal",
  HEX_COLOR_PRIMARY: "#00c3ff",
  HEX_COLOR_SUCCESS: "#00ca72"
};

export default BrandColors;